/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.CustomTag = (function () {
  function CustomTag() {
    this.data = null;
    this.selectedTags = null;
    this.entity = '';
    this.entityColumn = '';

    Monet.UI.Fields.Base.apply(this, arguments);

    this.setEntity = function (entity) {
      this.entity = entity;
    }

    this.setEntityColumn = function (entityColumn) {
      this.entityColumn = entityColumn;
    };

    this.createBaseStructure();

    this.renderInput = function () {
      this.input = document.createElement('ul');
      this.input.className = 'tagit ui-widget ui-widget-content ui-corner-all';
      this.rootEl.appendChild(this.input);
    }

    this.addTagsToComponent = function () {
      const availableTags = [];
      this.data.forEach(item => availableTags.push(item[this.entityColumn]));

      $(this.input).tagit({
        listTags: this.selectedTags,
        availableTags,
        allowSpaces: true,
      });
    };

    this.addEventListener = function () {
      $('.tagit-close').each(item => item.addEventListener('click', function (e) {
        this.removeTag(e.target.parentElement.parentElement);
      }.bind(this)))
    };

    var getHtmlTemplate = function (tags) {
      var div = document.createElement('div');

      for (var i = 0, length = tags.length; i < length; i++) {
        var li = document.createElement('li'),
          spanLabel = document.createElement('span'),
          spanLabel = document.createElement('span'),
          a = document.createElement('a'),
          spanText = document.createElement('span'),
          spanIcon = document.createElement('span'),
          input = document.createElement('input');

        li.className = 'tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable';
        spanLabel.className = 'tagit-label fromServer';
        a.className = 'tagit-close';
        spanText.className = 'text-icon';
        spanIcon.className = 'ui-icon ui-icon-close';

        spanLabel.appendChild(document.createTextNode(tags[i].name));
        spanText.appendChild(document.createTextNode('x'));

        input.type = 'hidden';
        input.value = tags[i].name;
        input.name = 'tags';
        input.className = 'tagit-hidden-field';

        a.appendChild(spanText);
        a.appendChild(spanIcon);

        li.appendChild(spanLabel);
        li.appendChild(a);
        li.appendChild(input);
        div.appendChild(li);
        li = null;
        spanLabel = null;
        a = null;
        spanText = null;
        spanIcon = null;
        input = null;
      }
      return div.innerHTML;
    };

    this.setValue = function (tags) {
      if (tags) {
        this.selectedTags = tags;
        if (this.input) {
          this.input.insertAdjacentHTML('afterbegin', getHtmlTemplate(tags));
        }
        this.addEventListener();
      }
    };

    this.getValue = function () {
      var list = this.rootEl.querySelectorAll('.tagit .tagit-choice'),
        listTags = [],
        tagValue;

      for (var i = 0; i < list.length; i++) {
        tagValue = list[i].children[0].innerHTML;
        if (tagValue) {
          listTags.push(tagValue);
        }
      }
      return listTags;
    };

    this.removeTag = function (tag) {
      var hide_args = [
        'blind',
        { direction: 'horizontal' },
        'fast',
        function () {
          $(tag).remove();
        },
      ];

      $(tag).addClass('removed').fadeOut('fast').hide.apply(tag, hide_args).dequeue();
    };

    this.retrieveDataFromServer = function () {
      if (this.entity) {
        var ajax = new Monet.Ajax();
        ajax.url = `${this.entity}/restrictions?criteria={"filters":["id", "${this.entityColumn}"]}`;
        ajax.method = 'POST';
        ajax.data = '{"criteriaChain":[]}';
        ajax.success = function (data) {
          if (data) {
            this.data = data;
            this.addTagsToComponent();
          }
        }.bind(this);
        ajax.error = function (responseText) {
          console.log('Error retrieving custom tags from server:', responseText);
        }.bind(this);
        ajax.send();  
      }

    };

    this.render = function () {
      this.renderInput();
      this.retrieveDataFromServer();

      return this.rootEl;
    };
  }

  return CustomTag;
})();
